module.exports = __webpack_public_path__ + "static/media/loginBg.6ecf79db.jpg";